export default __webpack_public_path__ + "static/media/token2.77b84dab.svg";